import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { formatDate, sortValue } from 'utils';
import { priceRender } from 'utils/table';

const type = {
  package: 'Пакет',
  service: 'Услуга',
};

export const columns = [
  {
    title: 'Наименование',
    dataIndex: 'title',
    key: 'title',
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
      return (
        <TableSearchPanel>
          <Input
            autoFocus
            placeholder="Поиск по наименованию"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
          />
        </TableSearchPanel>
      );
    },
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) => {
      return record?.title.toLowerCase().includes(value.toLowerCase());
    },
  },
  {
    title: 'Тип',
    dataIndex: 'type',
    key: 'type',
    render: (value) => type[value],
    filters: [
      {
        text: 'Пакет',
        value: 'package',
      },
      {
        text: 'Услуга',
        value: 'service',
      },
    ],
    onFilter: (value, record) => record.type === value,
    filterIcon: () => <FilterOutlined />,
  },
  {
    title: 'Цена (₸)',
    dataIndex: 'price',
    key: 'price',
    sorter: sortValue('price'),
    render: priceRender,
  },
  {
    title: 'Дата создания',
    dataIndex: 'created',
    key: 'created',
    render: (value) => formatDate(value),
  },
  {
    title: 'С Бухгалтером',
    dataIndex: 'with_accountant',
    key: 'with_accountant',
    render: (value) => (value ? 'Да' : 'Нет'),
    filters: [
      {
        text: 'C бухгалтером',
        value: true,
      },
      {
        text: 'Без бухгалтера',
        value: false,
      },
    ],
    onFilter: (value, record) => record.with_accountant === value,
    filterIcon: () => <FilterOutlined />,
  },
  {
    title: 'Активный',
    dataIndex: 'is_public',
    key: 'is_public',
    render: (value) => (value ? 'Да' : 'Нет'),
    filters: [
      {
        text: 'Активный',
        value: true,
      },
      {
        text: 'Не активный',
        value: false,
      },
    ],
    onFilter: (value, record) => record.is_public === value,
    filterIcon: () => <FilterOutlined />,
  },
];
